import { render, staticRenderFns } from "./JobFairRecommendList.vue?vue&type=template&id=be1b889a&scoped=true&"
import script from "./JobFairRecommendList.vue?vue&type=script&lang=js&"
export * from "./JobFairRecommendList.vue?vue&type=script&lang=js&"
import style0 from "./JobFairRecommendList.vue?vue&type=style&index=0&id=be1b889a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b889a",
  null
  
)

export default component.exports